import React from 'react';

export interface FaqItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  title: string;
  subtitle?: string;
  faqs: FaqItem[];
}

export function FAQSection({ title, subtitle, faqs }: FAQSectionProps) {
  return (
    <section className="py-14 bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900">{title}</h2>
        {subtitle && <p className="mt-3 text-gray-600">{subtitle}</p>}
        <div className="mt-8 space-y-4">
          {faqs.map((faq) => (
            <details key={faq.question} className="bg-white border rounded-lg p-5">
              <summary className="font-semibold text-gray-900 cursor-pointer">{faq.question}</summary>
              <p className="mt-3 text-gray-600 leading-relaxed">{faq.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
